const giftMapper = (appliedFilter) => {
  return {
    booleanFilters: [
      {
        column: 'IsGift',
        value: appliedFilter.criterionArgumentValue,
      },
    ],
  };
};

export default giftMapper;
